<template>
  <v-navigation-drawer :value="drawerVisible" @input="toggleDrawer($event)" fixed clipped app>
    <v-list dense>
      <v-list-tile v-for="item in sitemap" :key="item.text" @click="$router.push(item.route)">
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.text }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

    <v-spacer></v-spacer>

    <v-footer v-if="config.components.debug" light fixed bottom color="transparent" height="96">
      <v-list dense bottom fixed absolute>
        <v-list-tile>
          <v-list-tile-action>
            <v-icon>build</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title wrap>
              Project: {{project}}
              Version: {{ version }}
              Pipeline: {{ pipeline }}
              Build: {{ build }}
              Branch: {{ branch }}
              Commit: {{ commit }}
              Tag: {{ tag }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-footer>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { api } from "@/store/modules/app";
import { api as confApi } from "@/store/modules/configuration";

export default {
  computed: {
    ...mapState(api.namespace, [api.state.drawerVisible]),
    ...mapGetters(api.namespace, [api.getters.sitemap]),
    ...mapGetters(confApi.namespace, [confApi.getters.app]),
    config() {
      return this.app || { components: { debug: false } };
    },
    pipeline() {
      return process.env.VUE_APP_CI_PIPELINE_ID || "no pipeline info";
    },
    build() {
      return process.env.VUE_APP_CI_JOB_ID || "no build info";
    },
    branch() {
      return process.env.VUE_APP_CI_COMMIT_REF_NAME || "no branch info";
    },
    commit() {
      return process.env.VUE_APP_CI_COMMIT_SHA || "no commit info";
    },
    version() {
      return process.env.VUE_APP_PKG_VERSION || "no commit info";
    },
    tag() {
      return process.env.VUE_APP_CI_COMMIT_TAG || "no tag info";
    },
    project() {
      const data = JSON.parse(process.env.VUE_APP_FIREBASE_CONFIG);
      return data.projectId || "Unknown";
    }
  },
  methods: {
    ...mapActions(api.namespace, [api.mutations.toggleDrawer])
  }
};
</script>
